import { required } from "vuelidate/lib/validators";

export default class PlanoMensalData {
  id_faixa_revenda = "";

  id_plano = null;

  constructor({ id_faixa_revenda = "", id_plano = null }) {
    this.id_faixa_revenda = id_faixa_revenda;
    this.id_plano = id_plano;
  }
}

export const PlanoMensalDataRequired = {
  id_plano: {
    required
  },
  id_faixa_revenda: {
    required
  }
};
